import { env } from '@percent/admin-dashboard/env'

/**
 * Account ID of the VR automation (Ralph). The "Submit QC" button on the
 * validation request detail view is only shown when
 * `validation.reviewedBy.account` matches this id.
 *
 * Sourced per-environment from `NX_PUBLIC_VR_AUTOMATION_ACCOUNT_ID`.
 * When unset the gate never matches, so the button stays hidden.
 */
export const VR_AUTOMATION_ACCOUNT_ID = env.NX_PUBLIC_VR_AUTOMATION_ACCOUNT_ID ?? ''
